var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 7,
    viewBox: "0 0 38 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9852 6.4783C18.3802 6.04731 5.87515 3.92459 0.884577 2.31042C0.37443 2.14542 0.0977101 1.60916 0.22775 1.089C0.375582 0.497671 0.989393 0.152711 1.57527 0.320853C12.7114 3.51684 28.9985 4.42622 37.0154 4.49559C37.5622 4.50033 38 4.94333 38 5.4902C38 6.04466 37.5396 6.49114 36.9852 6.4783Z",
    fill: "#181111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthD);
export default __webpack_public_path__ + "static/media/Mouth D.a3a77eea5c15353f8638a5a2c0b958f5.svg";
export { ForwardRef as ReactComponent };